import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import { FaEnvelope, FaPhone, FaCalendarAlt, FaMapMarkerAlt, FaUniversity, FaUser, FaCreditCard, FaClock } from "react-icons/fa";
import { BsCheckCircleFill } from "react-icons/bs";
import ImageWithFallback from '../../../components/ImageWithFallback';

import { FaStar,  FaEllipsisH } from "react-icons/fa";
import { MdOutlineWork, MdAssignmentInd, MdDescription, MdCheckCircle, MdSchool, MdCake, MdPersonSearch, MdEmail, MdPhone, MdWc, MdHome } from "react-icons/md";
import { BsFillCircleFill } from "react-icons/bs";
import { CgArrowLeft, CgArrowRight , CgClose} from 'react-icons/cg';
import InterviewList from '../Cards/InterviewCard';
import ReviewCard from '../Cards/ReviewCard';
import JobApplicationCard from '../Cards/JobApplicationCard';
import { PATH_END_POINT } from '../../../../../api';


const CandidateModal = ({show =false, onClose, application , offer}) => {

    const [activeStep, setActiveStep] = useState(1);
    const [activeTab, setActiveTab] = useState("Entretien");

    const buttons = [
      { label: "Candidature", icon: <MdAssignmentInd className="text-lg" /> },
      { label: "Note", icon: <MdDescription className="text-lg" /> },
    //   { label: "Soumission", icon: <MdOutlineWork className="text-lg" /> },
      { label: "Entretien", icon: <MdCheckCircle className="text-lg" /> },
    ];

    const steps = [
      { id: 1, title: "Details", subtitle: "Some info about you.", icon: <FaUser /> },
      { id: 2, title: "Address", subtitle: "Where we sending it?", icon: <FaMapMarkerAlt /> },
      { id: 3, title: "Payment", subtitle: "Show us the money.", icon: <FaCreditCard /> },
    ];

    // const { user} = application;

  return (
    <>
        <AnimatePresence>
    {
        show && (
    
        <motion.div 
        initial={{ opacity: 0.8  }}
        animate={{opacity: 1}}
        exit={{ opacity: 0.8 }}
        className="fixed ease-in duration-200 z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm backdrop-filter">
        <motion.div
        // Animation pour l'apparition
        initial={{ opacity: 0.8, right: "-100%", y: 20 }}
        animate={{ opacity: 1, right: 0, y: 0 }}
        exit={{ opacity: 0.8, right: "-100%", y: 20 }}
        transition={{ type: "spring", stiffness: 130, damping: 20 }}
        className="fixed  overflow-y-auto overflow-x-hidden bg-white w-full lg:w-1/2 xl:w-[75%] min-h-full lg:rounded-s-2xl drop-shadow-lg max-h-screen pt-4 pb-6"
        >
            <div className="pb-4 px-6 border-b flex justify-between mb-4">
                <div className="flex items-center gap-2">
                <button className="border rounded-full p-2 hover:bg-gray-50">
                <CgArrowLeft></CgArrowLeft>
                </button>
                <button className="border rounded-full p-2 hover:bg-gray-50">
                <CgArrowRight/>
                </button>
                <span className="text-sm text-gray-500">
                    Page 1 sur {offer?.applications?.length}
                </span>
                </div>

                <button onClick={onClose} className="border rounded-full p-2 hover:bg-gray-50">
                <CgClose/>
                </button>
               
            </div>
             <div className="">


    <div className="w-full ">
      <div className="flex items-center justify-between border-b pb-6 mb-6 px-6" >
        <div className="flex items-center gap-4">
          <ImageWithFallback
            src={PATH_END_POINT+ application?.user?.photo}
            alt="Profil"
            defaultType='user'
            className="w-16 h-16 rounded-full object-cover"
          />
          <div>
            <h2 className="text-lg font-semibold">{application?.user?.name}</h2>
            <div className="flex items-center gap-2 text-sm text-gray-600">
                <button className="border px-1.5 py-0.5 rounded-full flex items-center gap-1">
                    <FaStar className="text-yellow-500" />
                    <span className="font-semibold text-xs">{application?.score}.0 Avis</span>
                </button>
              
              <div className="flex items-center gap-1 bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">
                <BsFillCircleFill className="text-green-500 w-2 h-2" />
                <span>Active</span>
              </div>
            </div>
            <div className="text-xs text-gray-500 mt-1 grid grid-cols-3 w-full gap-4  sm:gap-6">
              <div><span className="font-semibold">Origine:</span> {offer?.job_title}</div>
              <div><span className="font-semibold">Postulé le:</span> {application?.created_at}</div>
              <div><span className="font-semibold">Poste:</span> {application?.user?.candidate_profile?.current_job}</div>
            </div>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          <button className="bg-gray-900 text-white px-4 py-4 rounded-lg flex items-center gap-2 hover:bg-gray-800">
            <FaEnvelope />
          </button>
        </div>
      </div>


<div className='px-6 pb-6 border-b'>
  <StepIndicator currentStep={3}/>

</div>     
    </div>
      
    <div className="bg-neutral-50 min-h-[400px] px-6">
      <div className="grid grid-cols-12 divide-x ">
            <div className=" col-span-8 mr-6 py-4 space-y-4 text-wrap">
            <div className="flex gap-4 text-sm">
      {buttons.map((btn) => (
        <button
          key={btn.label}
          onClick={() => setActiveTab(btn.label)}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full border transition-all 
            ${activeTab === btn.label ? "bg-black text-white" : "border-gray-300 text-gray-500 hover:text-black"}
          `}
        >
          {btn.icon} {btn.label}
        </button>
      ))}
    </div>
            {activeTab === "Candidature" && <JobApplicationCard application = {application} offer={offer}/>}
            {activeTab === "Note" && <ReviewCard application = {application}/>}
            {activeTab === "Entretien" &&  <InterviewList application ={application}/>}
            
           
            
            </div>
            <div className="max-w-md mx-auto p-4 ">
      <div className="mb-6 space-y-4">
        <h2 className="text-lg font-semibold mb-4">Informations personnelles</h2>
        <InfoRow icon={MdEmail} label="Adresse e-mail" value={application?.user?.email} isBlue/>
        <InfoRow icon={MdPhone} label="Numéro de téléphone" value={application?.user?.candidate_profile?.phone} isBlue/>
        <InfoRow icon={MdWc} label="Genre" value={application?.user?.candidate_profile?.gender} />
        <InfoRow icon={MdCake} label="Date de naissance" value={application?.user?.candidate_profile?.date_birth} />
        <InfoRow icon={MdHome} label="Adresse" value={application?.user?.candidate_profile?.address} />
      </div>

      {/* Informations sur l'éducation */}
      <div className="mb-6 space-y-4">
        <h2 className="text-lg font-semibold mb-4">Informations sur l'éducation</h2>
        {application?.user?.candidate_profile?.educations &&
          application?.user?.candidate_profile?.educations.map((education) => (
            <div key={education.id} className="space-y-2">
              <InfoRow icon={MdSchool} label="Université" value={education.school} />
              <InfoRow icon={MdCheckCircle} label="Diplôme" value={education.diploma} />
              <InfoRow icon={MdCake} label="Année d'obtention du diplôme" value={education.end_year} />
            </div>
          ))}
        <div className="flex items-center">
          <MdPersonSearch className="size-4 text-gray-500" />
          <span className="font-medium">Référence</span>
          <span className="ml-auto">Non fourni</span>
        </div>
      </div>
    </div>
        </div>
        </div>    

    </div>

        </motion.div>
        </motion.div>)
    }
   </AnimatePresence>
    </>
  )
}


const StepIndicator= ({ currentStep }) => {
    const steps = [
        { title: "Nouveau" },
        { title: "Sélectionné" },
        { title: "Entretien" },
        { title: "Recruté" },
        { title: "Refusé" },
      ];
      
    return (
      <div className="w-full">
        {/* <p className='text-sm mb-2'>Etat actuel</p> */}
        <ol className="grid grid-cols-5 divide-x divide-gray-100 overflow-hidden rounded-lg border border-gray-100 text-sm text-gray-500">
          {steps.map((step, index) => {
            const isCompleted = (index + 1) < currentStep;
            const isCurrent = index + 1 === currentStep;
  
            return (
              <li
                key={index}
                className={`relative flex items-center justify-center gap-2 p-4 ${
                  isCurrent ? "bg-[#b4ff92] text-black" :
                  isCompleted ? "bg-primary-beige text-black" :
                  "bg-white"
                }`}
              >
                {/* Flèche à gauche sauf pour la première étape */}
                {index !== 0 && (
                  <span
                    className={`absolute -left-2 top-1/2 hidden size-4 -translate-y-1/2 -rotate-45 z-20   sm:block  border border-gray-100 border-t-0 border-l-0 
                  
                    ${
                        ( (index) < currentStep) ? "bg-primary-beige " :
                        ( index === currentStep) ? " bg-[#b4ff92]" :
                        "bg-white"
                      }
                    `}
                  />
                //     //     ${
                    //   isCompleted ? "bg-primary-beige" : "bg-white"
                    // }
                )}
  
                <p className="leading-none">
                  <strong className="block font-medium">{step.title}</strong>
                </p>
  
                {/* Flèche à droite sauf pour la dernière étape */}
                {index !== steps.length - 1 && (
                  <span
                    className={`absolute -right-2 top-1/2 hidden size-4 -translate-y-1/2 rotate-45  sm:block  ${
                      isCurrent ? "bg-[#b4ff92]" :
                      isCompleted ? "bg-primary-beige" :
                      "bg-white"
                    }`}
                  />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    );
  };
export default CandidateModal


const InfoRow =({ icon: Icon, label, value, isBlue=false }) =>{
  return (
    <div className= "flex items-center text-nowrap text-sm gap-2 mb-2">
      <Icon className="size-4 text-gray-500" />
      <span className="font-medium">{label}</span>
      <span className={ isBlue ? "ml-auto text-blue-600 px-2 py-1 border rounded-full border-blue-300" : "ml-auto"}>{value}</span>
    </div>
  );
}
